import { trimEnd } from "lodash-es";
export const PROGRESS_LABEL = "linear-progress-label";
export const BACK_BUTTON_TEXT = "linear-progress-label-back-btn-txt";
export const MODE_ALL = "all";
export const EMPTY = "";
export const TRUE = true;
export const NEXT_STEP = "next-step";
export const CANCEL = "cancel";
export const SUBMIT = "submit";
export const PRIMARY_FORM_CARD_ID = "create-account-card";
export const LOG_IN = "log-in";
export const LOG_IN_BUTTON = "log-in-button";
export const WARNING_ICON_ID = "warning-icon-id";
export const CANCEL_BUTTON = "cancel-button";
export const CONSUMER_VIEW = "consumer";
export const ADMIN_PROVIDER_VIEW = "adminProvider";
export const APP_MODE_DEV = "development";
export const APP_MODE_VPN = "vpn";
export const PAGE_VIEW = "pageView";
export const NOT_SIGNED_IN = "Not Signed In";
export const ERROR_CONTACT_INFO = "errorContactInfo";
export const LOCALE = "locale";
export const LOCALE_EN = "en";
export const LOCALE_ES = "es";
export const UNDEFINED = "undefined";
export const HOST_PORT = "{HOST_PORT}";
export const CONTACT_NUMBER = "contactNumber";
export const FPACT_EMAIL_ADDRESS = "fpactEmailAddress";
export const PROVIDER_CONTACT_NUMBER = "providerContactNumber";
export const APPLICATION = "application";
export const API_ACTION_VERIFY = "verify";
export const API_ACTION_VALIDATE = "validate";
export const MODE_ON_SUBMIT = "onSubmit";
export const MODE_ON_BLUR = "onBlur";
export const PREFERRED_VERIFICATION_PAGE = "4/4";
export const LINEAR_PROGRESS_LABEL = "linear-progress-label";
export const CONTACT_US_PAGE = "https://www.coveredca.com/support/contact-us/";
export const CONSUMER_ACCOUNT_CREATION = "consumer-account-creation";
export const EDIT_VERIFICATION = "edit-verification-method";
export const REGISTER_VERIFICATION = "register-verification-method";
export const ENABLE_ACCOUNT = "enable-account";
export const PROVIDER_ACCOUNT_CREATION = "provider-account-creation";
export const ACCOUNT_CREATION_SUCCESSFUL = "ACCOUNT_CREATION_SUCCESSFUL";
export const BUTTON = "button";
export const DISABLED = "disabled";
export const INITIAL = "initial";
export const TEXT_SECONDARY = "text.secondary";
export const ASTERISK_SYMBOL = "*";
export const AT_SYMBOL = "@";
export const CIRCLE_UNICODE = "\u25CF";
export const INVISIBLE = "invisible";
export const GOOGLE_CAPTCHA_SITE_KEY = "googleCaptchaSiteKey";
export const GOOGLE_CAPTCHA_INTERNAL_ERROR = "Unable to validate recaptcha!";
export const COLON_SYMBOL = ":";
export const EMPTY_STRING = "";
export const RESPONSE_CODE_406 = 406;
export const RESPONSE_CODE_200 = 200;
export const RESPONSE_CODE_201 = 201;
export const UI_OPTIONS = "uiOptions";
export const FORGOT_PASSWORD_CHALLENGE = "FORGOT_PASSWORD_CHALLENGE";
export const FORGOT_PASSWORD_ALLOW = "FORGOT_PASSWORD_ALLOW";
export const USER_VERIFIED_SUCCESSFULLY = "USER_VERIFIED_SUCCESSFULLY";
export const CREATE_ACCOUNT_BUTTON = "create-account-button";
export const USER_NAME_LABEL = "user-name-label";
export const USER_NAME_VALUE = "user-name-value";
export const CONTINUE_BUTTON = "continue-button";
export const EMAIL_ALREADY_EXISTS = "EMAIL_ALREADY_EXISTS";
export const PHONE_NUM_ALREADY_EXISTS = "PHONE_NUM_ALREADY_EXISTS";
export const FIND_PROVIDER_LINK = "find-provider-link";
export const FIND_PROVIDER_URL = "findProviderUrl";
export const EMAIL = "email";
export const REGISTER_ACTION = "register";
export const APPLICATION_NAME = "fpact-react-account";
export const ACCOUNT_CREATION_SUCCESSFUL_TOAST =
  "account-creation-successful-toast";
export const PASSWORD_UPDATE_SUCCESSFUL_TOAST =
  "password-update-successful-toast";
export const ACCESS_CODE_VERIFICATION_FAILED =
  "access-code-verification-failed";
export const ACCOUNT_CREATION_FLOW = "accountCreationFlow";
export const ACCOUNT_CREATION_BROWSER_TITLE =
  "Account Creation/Login | California Family PACT";
export const CLIENT_PORTAL_BROWSER_TITLE =
  "Client Portal | California Family PACT";
export const PROVIDER_PORTAL_BROWSER_TITLE =
  "Provider Portal | California Family PACT";
export const ADMIN_PORTAL_BROWSER_TITLE =
  "Admin Portal | California Family PACT";
export const ENV_DEV = "development";
export const ENV_TEST = "test";
export const ENV_VPN = "vpn";
export const ENTER = "Enter";
export const SPAN = "span";
export const SMS_MOCK_OTP_ID = "sms-mock-otp";
export const FPACT_EMAIL_ADDRESS_ID = "fpact-email-address-id";
export const FPACT_EMAIL_ADDRESS_SPAM_ID = "fpact-email-address-spam-id";
export const CONTACT_INFO_ID = "contact-info-id";
export const TYPE_STRING = "string";
export const SUBMIT_DATE_FORMAT = "MM/dd/yyyy";
export const TIME_SHIFTER_DATE_FORMAT = "yyyy-MM-dd";
export const IS_RECAPTCHA_ENABLED = "isReCaptchaEnabled";
export const EMAIL_OR_PHONE_ALREADY_EXISTS = "EMAIL/PHONE_ALREADY_EXISTS";
export const PRIVACY_POLICY_LINK = "privacyPolicyLink";
export const EMAIL_LANGUAGE = "emailLanguage";
export const EMAIL_LANGUAGE_LABEL = "email-language-label";
export const EMAIL_LANGUAGE_TOOLTIP_TEXT = "email-language-tooltip-text";
export const EMAIL_LANGUAGE_HELPER_TEXT = "email-language-helper-text";
export const DESCRIPTION_EN = "EN";
export const DESCRIPTION_SP = "SP";
export const EMAIL_LANGUAGE_VALUE = "email-language-value";
export const YES_VALUE = "1";
export const NO_VALUE = "0";
export const DASH = "—";
export const providerRequestsScopes = ["Super_Admin"];
export const STATUS_PENDING = "PENDING";

/* Spacing Constants */
export const SPACING_4_5 = { xs: 4, md: 5 };
export const SPACING_3_5 = { xs: 3, md: 5 };
export const SPACING_3_2 = { xs: 3, md: 2 };
export const SPACING_3_4 = { xs: 3, md: 4 };
export const SPACING_5_4 = { xs: 5, md: 4 };
export const SPACING_4_3 = { xs: 4, md: 3 };
export const SPACING_2_5__2 = { xs: 2.5, md: 2 };
export const SPACING_8__10 = { xs: 8, md: 10 };

export const SM = "sm";

/* Variants */
export const H1 = "h1";
export const H2 = "h2";
export const H3 = "h3";
export const H4 = "h4";
export const SUBTITLE = "subtitle";
export const P_REGULAR = "pRegular";
export const P_REGULAR_SEMI_BOLD = "pRegularSemibold";
export const INFO = "info";
export const CONTAINED = "contained";
export const OUTLINED = "outlined";
export const TEXT = "text";
export const P_LARGE_SEMI_BOLD = "pLargeSemibold";
export const P_LARGE = "pLarge";
export const SECONDARY_MAIN = "secondary.main";
export const TARGET_BLANK = "_blank";

export const MOCK_TOKEN = "mock-token";
export const SESSION_AUTH_TOKEN = "authToken";
export const FOOTER_CONTACT_NUMBER = "footerContactNumber";
export const WIDTH_100_PERCENT = "100%";
export const WIDTH_50_PERCENT = "50%";

/*Route Constants */
export const ACCOUNT_CREATION_ROUTE = "account-creation";
export const LINK_APPLICATION_ROUTE = "link-application";
export const LINK_APPLICATION_RESULTS_ROUTE = "link-application-results";
export const SEARCH_HAP_ID_ROUTE = "search-hap-id";
export const NAME_AND_CONTACT_ROUTE = "name-and-contact";
export const LOGIN_ROUTE = "login";
export const STATIC = "/static";
export const BASE_ROUTE = "/";
export const REVIEW_APPLICATION_ROUTE = "review-application";
export const REVIEW_INFO_ROUTE = "review-info";
export const VERIFY_ACCOUNT_ROUTE = "verify-account";
export const PROVIDER_REVIEW_INFO = "provider-review-info";
export const PROVIDER_INFO = "provider-info";
export const CONFIRM_SITE_ACCESS_ROUTE = "confirm-site-access";
export const LEGAL_NOTICE_ROUTE = "legal-notice";
export const CLIENT_MANAGEMENT_ROUTE = "client-management";
export const ADMIN_DASHBOARD_ROUTE = "admin-dashboard";
export const FORGOT_USERNAME_ROUTE = "forgot-username";
export const FORGOT_USERNAME_EMAIL_SENT = "forgot-username-email-sent";
export const FORGOT_PASSWORD_ROUTE = "forgot-password";
export const RESET_PASSWORD_ROUTE = "reset-password";
export const ENABLE_ACCOUNT_ROUTE = "enable-account";
export const ACCOUNT_SETUP_ROUTE = "account-setup";
export const FORGOT_PASSWORD = "forgot-password";
export const MY_PROFILE_ACCOUNT_SETTINGS_ROUTE = "account-settings";
export const LOGIN_INFORMATION_ROUTE = "login-information";
export const SITE_ACCESS_ROUTE = "site-access";
export const PERSONAL_DETAILS_ROUTE = "personal-details";
export const SECURITY_PREFERENCES_ROUTE = "security-preferences";
export const EMAIL_SENT = "/email-sent";
export const MANAGE_VERIFICATION_METHOD = "manage-verification-method";
export const LOGIN_VERIFICATION_METHOD_ROUTE = "login-verification-methods";
export const MY_PROFILE_ROUTE = "my-profile";
export const CONSUMER_ROUTE = "lw-consumer";
export const PROVIDER_ADMIN_ROUTE = "lw-provideradmin";
export const CASE_HISTORY_ROUTE = "case-history";


export const CONSUMER_USER_ROLE_ID = 604;
export const PROVIDER_SITE_CERTIFIER_USER_ROLE_ID = 605;
export const PROVIDER_STAFF_USER_ROLE_ID = 606;
export const MESSAGE_CENTRE = "message-center";
export const ACCOUNT_SETTINGS = "/account-settings";
export const CASE_HISTORY = "/case-history";
export const DISCONTINUE = "discontinue";
export const LOGOUT_ROUTE = "lw-account/login";
export const ACCOUNT_BASE_ROUTE = "lw-account";
export const PROFILE_BASE_ROUTE = "account-settings";
export const SLASH = "/";
export const CONSUMER_DASHBOARD_ROUTE = "lw-consumer-dashboard";
export const USER_ACCOUNT_ADMINISTRATION_ROUTE = "user-account-administration";
export const ACCESS_MANAGEMENT_DASHBOARD_ROUTE = "access-management-dashboard";
export const PROVIDER_REQUESTS_ROUTE = "provider-requests";

/* User role constants */
export const SCR_ADMIN = "SCR_Admin";
export const SUPER_ADMIN = "Super_Admin";
export const READ_ONLY_ADMIN = "Read_Only_Admin";
export const PROVIDER_STAFF = "Provider_Staff";
export const PROVIDER_SITE_CERTIFIER = "Provider_Site_Certifier";
export const CONSUMER_USER = "Consumer";
export const SITE_DISPLAY_ROLES = ["Provider_Staff", "Provider_Site_Certifier"];
export const PROVIDER_SITE_MANAGER = "ProviderSiteManager";

export const COMPONENT_H1 = "h1";
export const VARIANT_H2 = "h2";
export const VARIANT_H3 = "h3";
export const VARIANT_H4 = "h4";
export const VARIANT_P_REGULAR = "pRegular";
export const VARIANT_P_LARGE_SEMI_BOLD = "pLargeSemibold";
export const COMPONENT_H2 = "h2";
export const STRETCH = "stretch";
export const MAIN = "main";

/* Timeout Constants*/
export const TIMEOUT_VALUE = 780000;
export const MODAL_TIMEOUT = 900000;
export const PROMPT_BEFORE_IDLE = 120000;
export const DEFAULT_TIME_ZONE = "America/Los_Angeles";
export const THROTTLE_TIME = 500;

/* Route arrays for different layout area */
export const overlappingFooter = [
  `/${ACCOUNT_CREATION_ROUTE}/${PROVIDER_REVIEW_INFO}`,
  `/${ACCOUNT_CREATION_ROUTE}/${PROVIDER_INFO}`,
];
export const noSwooshIcon = [
  `/${LOGIN_ROUTE}`,
  `/${MY_PROFILE_ACCOUNT_SETTINGS_ROUTE}`,
  `/${MY_PROFILE_ACCOUNT_SETTINGS_ROUTE}/${LOGIN_INFORMATION_ROUTE}`,
  `/${MY_PROFILE_ACCOUNT_SETTINGS_ROUTE}/${SECURITY_PREFERENCES_ROUTE}`,
  `/${MY_PROFILE_ACCOUNT_SETTINGS_ROUTE}/${SITE_ACCESS_ROUTE}`,
];
export const siteAccessCard = [
  `/${ACCOUNT_CREATION_ROUTE}/${CONFIRM_SITE_ACCESS_ROUTE}`,
];

export const MY_PROFILE_ROUTES = {
  accountSettings: `/${MY_PROFILE_ACCOUNT_SETTINGS_ROUTE}`,
  loginInformation: `/${MY_PROFILE_ACCOUNT_SETTINGS_ROUTE}/${LOGIN_INFORMATION_ROUTE}`,
  securityPreferences: `/${MY_PROFILE_ACCOUNT_SETTINGS_ROUTE}/${SECURITY_PREFERENCES_ROUTE}`,
  siteAccess: `/${MY_PROFILE_ACCOUNT_SETTINGS_ROUTE}/${SITE_ACCESS_ROUTE}`,
};

export const cardDisplayRoutes = [
  `/${MY_PROFILE_ACCOUNT_SETTINGS_ROUTE}/${RESET_PASSWORD_ROUTE}`,
  `/${MY_PROFILE_ACCOUNT_SETTINGS_ROUTE}/${MANAGE_VERIFICATION_METHOD}`,
  `/${MY_PROFILE_ACCOUNT_SETTINGS_ROUTE}/${VERIFY_ACCOUNT_ROUTE}`,
];
export const getMatchingRoutes = (pathname, matchingArray) => {
  if (matchingArray && matchingArray?.length > 0) {
    const matchedItem = matchingArray.find((item) => {
      const trimmedPathName = trimEnd(pathname, "/");
      return trimmedPathName === item;
    });
    return matchedItem;
  }
  return false;
};
export const GTM_ID = "reactGtmId";
export const SIGNED_IN = "Signed In";
export const STATIC_DATA = "static/";
export const SIGNED_IN_ROUTES = [
  "/login/verify-account",
  "/login/legal-notice",
  "/login/manage-verification-method",
  "/login/login-verification-methods",
  "/account-settings",
];
export const APPLICATION_HISTORY = "application-history";
export const CONFIRM_SITE_ACCESS_ROUTES = [
  "/account-creation/confirm-site-access/",
  "/account-creation/confirm-site-access",
];

export const NOTIFICATIONS = "notifications";
export const NOTIFICATION_SCOPES = [
  "Provider_Site_Certifier",
  "Provider_Staff",
];
export const NOTIFICATIONS_ROUTE = "notifications";
export const OVERIDE_ELIGIBILITY_ENABLED = "overrideEligibilityEnabled";
